import React, { useState } from 'react';
import StaffTasksPage from './StaffTasksPage';
import StaffOnboardingPage from './StaffOnboardingPage';

// ChecklistsHubPage consolidates Staff Tasks + Onboarding into one workspace
// (both are checklist-style flows — daily SOP tasks vs new-hire onboarding).
const TABS = [
  { key: 'tasks',      label: 'Daily Tasks',  render: (p) => <StaffTasksPage {...p} /> },
  { key: 'onboarding', label: 'Onboarding',   render: (p) => <StaffOnboardingPage {...p} /> },
];

const LEGACY_MAP = {
  'staff-tasks':      'tasks',
  'staff-onboarding': 'onboarding',
};

const ChecklistsHubPage = ({ API_BASE, currentUser, users, initialTab = 'tasks' }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = TABS.find(t => t.key === tab) || TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '9px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.86rem',
              backgroundColor: tab === t.key ? '#0D9488' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {Active.render({ API_BASE, currentUser, users })}
    </div>
  );
};

export default ChecklistsHubPage;
